export const radii = {
  default: '4px',
  exagerated: '8px',
  defaultRoundRightOnly: '0 4px 4px 0',
  defaultRoundLeftOnly: '4px 0 0 4px',
  defaultRoundTopOnly: '4px 4px 0 0',
  defaultRoundBottomOnly: '0 0 4px 4px',
  exageratedRoundRightOnly: '0 8px 8px 0',
  exageratedRoundLeftOnly: '8px 0 0 8px',
  exageratedRoundTopOnly: '8px 8px 0 0',
  exageratedRoundBottomOnly: '0 0 8px 8px',
};
